$ = jQuery;

function clinicFinderSubmit() {
  $(document).on('change', '#edit-secondary input[type="checkbox"]', function() {
    const $form = $(this).closest('form');
    const $submitButton = $form.find('input[type="submit"], button[id*="edit-submit"]');

    if ($submitButton.length) {
      $submitButton.click();
    } else {
      $form.submit();
    }
  });
}


